module.exports = __webpack_public_path__ + "static/img/3-4.5539967.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature/face/3-4.png
// module id = 6SQy
// module chunks = 1